import { render } from "./teaStudioHome.vue?vue&type=template&id=a90efcac&scoped=true"
import script from "./teaStudioHome.vue?vue&type=script&lang=js"
export * from "./teaStudioHome.vue?vue&type=script&lang=js"

import "./teaStudioHome.vue?vue&type=style&index=0&id=a90efcac&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90efcac"]])

export default __exports__